(function () {
  if (window.__bcEntryBadgesEnhanced) return;
  window.__bcEntryBadgesEnhanced = true;

  const platformId = 'gid://shopify/Shop/72931115206';
  const detailsCache = new Map();

  function toProductGid(value) {
    if (!value) return null;
    return String(value).indexOf('gid://shopify/Product/') === 0
      ? String(value)
      : `gid://shopify/Product/${value}`;
  }

  function parseMoneyToCents(text) {
    const amount = parseFloat(String(text || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(amount) && amount > 0 ? Math.round(amount * 100) : null;
  }

  function getUnitPriceCents(target) {
    const attr = Number(target.dataset.bcEntryUnitPriceCents);
    if (Number.isFinite(attr) && attr > 0) return attr;

    const root = target.closest('.card--sticky-atc, .cart-item') || target;
    const priceEl =
      root.querySelector('.price__current .js-value')
      || root.querySelector('.price .js-value')
      || root.querySelector('.price__current')
      || root.querySelector('.price');

    return priceEl ? parseMoneyToCents(priceEl.textContent) : null;
  }

  function formatProductSubtotalFromCents(cents) {
    const num = parseInt(cents, 10);
    return Number.isNaN(num) ? 0 : num / 100;
  }

  function formatEntries(value) {
    return `${Number(value).toLocaleString()} Entries`;
  }

  function createBadge(extraClass) {
    const wrap = document.createElement('div');
    wrap.className = `bc-entry-badge-wrap${extraClass ? ` ${extraClass}` : ''}`;
    wrap.innerHTML = `
      <div class="bc-entry-badge">
        <span class="bc-entry-badge__entries">Loading entries...</span>
        <span class="bc-entry-badge__multiplier"></span>
      </div>
    `;
    return wrap;
  }

  function ensureBadge(target) {
    let badge = target.querySelector('.bc-entry-badge-wrap');
    if (!badge) {
      badge = createBadge(target.dataset.bcEntryTarget === 'sticky' ? 'bc-entry-badge-wrap--sticky' : '');
      target.replaceChildren(badge);
    }
    return badge;
  }

  async function fetchSweepstakeDetails(productId) {
    if (detailsCache.has(productId)) return detailsCache.get(productId);

    const promise = (async () => {
      const query = `
        query QuerySweepstakeDetailsByProductId(
          $platform:String!
          $platformId:String!
          $productIds:[String!]
        ){
          sweepstakeDetailsByProductId(
            platform:$platform
            platformId:$platformId
            productIds:$productIds
          ){
            id
            entryManagement
            productsAllowedByDefault
            bonusEntriesDefault
            scheduledBonusValue
            scheduledBonusActive
            products(productIds:$productIds){
              productId
              productAllowed
              productBonusEntries
              productMultiplier
            }
          }
        }`;

      const response = await fetch('https://backend.cleansweeps.app/graphql', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          query,
          variables: {
            platform: 'Shopify',
            platformId,
            productIds: [productId]
          }
        })
      });

      if (!response.ok) throw new Error('CleanSweeps request failed');

      const { data } = await response.json();
      const details = data && data.sweepstakeDetailsByProductId
        ? data.sweepstakeDetailsByProductId
        : [];

      return details[0] || null;
    })();

    detailsCache.set(productId, promise);
    return promise;
  }

  function calculateEntries(detail, productId, unitPriceCents) {
    if (!detail) {
      return { isEligible: false, finalEntries: 'Entries unavailable' };
    }

    const productSpecial = detail.products && detail.products.length
      ? detail.products.find((product) => product.productId === productId)
      : null;

    let entryManagement = {};
    try {
      entryManagement = JSON.parse(detail.entryManagement || '{}');
    } catch (e) {
      entryManagement = {};
    }

    const dollarSpent = parseFloat(entryManagement.dollarSpent);
    const baseEntriesPer = parseFloat(entryManagement.entryPer);
    const scheduledBonusValueNum = Number(detail.scheduledBonusValue);
    const entriesPer =
      detail.scheduledBonusActive === true
      && Number.isFinite(scheduledBonusValueNum)
      && scheduledBonusValueNum > 0
        ? scheduledBonusValueNum
        : baseEntriesPer;

    if (!Number.isFinite(dollarSpent) || dollarSpent <= 0 || !Number.isFinite(entriesPer)) {
      return { isEligible: false, finalEntries: 'Entries unavailable' };
    }

    const rounding = entryManagement.roundUp !== undefined ? entryManagement.roundUp : true;
    const roundingFunction = rounding ? Math.ceil : Math.floor;
    const formattedProductSubtotal = formatProductSubtotalFromCents(unitPriceCents);
    let finalEntries;

    if (!productSpecial) {
      if (!detail.productsAllowedByDefault) {
        return { isEligible: false, finalEntries: 'Product Not Eligible' };
      }

      finalEntries =
        roundingFunction((entriesPer / dollarSpent) * roundingFunction(formattedProductSubtotal))
        + Number(detail.bonusEntriesDefault || 0);
    } else {
      if (!productSpecial.productAllowed) {
        return { isEligible: false, finalEntries: 'Product Not Eligible' };
      }

      finalEntries =
        roundingFunction((entriesPer / dollarSpent) * roundingFunction(formattedProductSubtotal))
        * Number(productSpecial.productMultiplier || 1)
        + Number(productSpecial.productBonusEntries || 0);
    }

    return { isEligible: true, finalEntries };
  }

  function calculateDisplayMultiplier(finalEntries, unitPriceCents) {
    const entriesNum = Number(finalEntries);
    const priceNum = formatProductSubtotalFromCents(unitPriceCents);

    if (!Number.isFinite(entriesNum) || !Number.isFinite(priceNum) || priceNum <= 0) {
      return null;
    }

    return Math.round(entriesNum / priceNum);
  }

  function applyMultiplierVisual(multiplierEl, multiplierValue) {
    if (!multiplierEl || !Number.isFinite(multiplierValue)) return;

    multiplierEl.classList.remove(
      'bc-tier-100',
      'bc-tier-200',
      'bc-tier-300',
      'bc-tier-400',
      'bc-tier-500'
    );

    let tierClass = 'bc-tier-100';
    if (multiplierValue >= 101 && multiplierValue <= 125) tierClass = 'bc-tier-200';
    else if (multiplierValue >= 126 && multiplierValue <= 199) tierClass = 'bc-tier-300';
    else if (multiplierValue >= 200) tierClass = 'bc-tier-500';

    multiplierEl.classList.add(tierClass);
  }

  function setBadgeState(target, result, unitPriceCents) {
    const badge = ensureBadge(target);
    const entriesEl = badge.querySelector('.bc-entry-badge__entries');
    const multiplierEl = badge.querySelector('.bc-entry-badge__multiplier');
    const quantity = Math.max(1, Number(target.dataset.bcEntryQuantity || 1));

    if (!result.isEligible || typeof result.finalEntries !== 'number') {
      target.dataset.bcEntryTotal = '';
      entriesEl.textContent = result.finalEntries || 'Entries unavailable';
      multiplierEl.textContent = '';
      multiplierEl.classList.remove('active');
      return;
    }

    const displayEntries = target.dataset.bcEntryTarget === 'cart-line'
      ? result.finalEntries * quantity
      : result.finalEntries;

    target.dataset.bcEntryTotal = String(displayEntries);
    entriesEl.textContent = formatEntries(displayEntries);

    const displayMultiplier = calculateDisplayMultiplier(result.finalEntries, unitPriceCents);
    if (displayMultiplier && displayMultiplier > 1) {
      multiplierEl.textContent = `${displayMultiplier}X`;
      applyMultiplierVisual(multiplierEl, displayMultiplier);
      multiplierEl.classList.add('active');
    } else {
      multiplierEl.textContent = '';
      multiplierEl.classList.remove('active');
    }
  }

  async function renderTarget(target) {
    const productId = toProductGid(target.dataset.bcEntryProductGid || target.closest('.cart-item')?.dataset.productId);
    const unitPriceCents = getUnitPriceCents(target);
    const quantity = target.dataset.bcEntryQuantity || target.closest('.cart-item')?.dataset.bcEntryQuantity || 1;
    const key = `${productId || ''}|${unitPriceCents || ''}|${quantity}`;

    if (!productId || !unitPriceCents) return;
    if (target.dataset.bcEntryKey === key && target.dataset.bcEntryStatus === 'done') return;
    if (target.dataset.bcEntryKey === key && target.dataset.bcEntryStatus === 'loading') return;

    target.dataset.bcEntryKey = key;
    target.dataset.bcEntryStatus = 'loading';
    ensureBadge(target);

    try {
      const detail = await fetchSweepstakeDetails(productId);
      const result = calculateEntries(detail, productId, unitPriceCents);
      setBadgeState(target, result, unitPriceCents);
      target.dataset.bcEntryStatus = 'done';
    } catch (error) {
      const badge = ensureBadge(target);
      badge.querySelector('.bc-entry-badge__entries').textContent = 'Entries unavailable';
      badge.querySelector('.bc-entry-badge__multiplier').classList.remove('active');
      target.dataset.bcEntryTotal = '';
      target.dataset.bcEntryStatus = 'error';
      console.error('Boosted cart entry badge error:', error);
    } finally {
      updateCartTotals();
    }
  }

  function updateCartTotals() {
    const lineTargets = [...document.querySelectorAll('[data-bc-entry-target="cart-line"]')];
    const totalTargets = [...document.querySelectorAll('[data-bc-cart-entry-total]')];

    if (!totalTargets.length) return;

    if (!lineTargets.length) {
      totalTargets.forEach((target) => { target.hidden = true; });
      return;
    }

    let total = 0;
    let pending = false;

    lineTargets.forEach((target) => {
      const value = Number(target.dataset.bcEntryTotal);
      if (Number.isFinite(value) && value > 0) {
        total += value;
      } else if (target.dataset.bcEntryStatus !== 'done' && target.dataset.bcEntryStatus !== 'error') {
        pending = true;
      }
    });

    totalTargets.forEach((target) => {
      const valueEl = target.querySelector('.bc-cart-entry-total__value');
      target.hidden = false;
      const text = pending && total === 0
        ? 'Loading...'
        : formatEntries(total);
      if (valueEl) {
        if (valueEl.textContent !== text) valueEl.textContent = text;
      }
    });
  }

  function scanEntryTargets() {
    document.querySelectorAll('[data-bc-entry-target]').forEach(renderTarget);
    updateCartTotals();
  }

  let scanQueued = false;
  function scheduleScan() {
    if (scanQueued) return;
    scanQueued = true;
    setTimeout(() => {
      scanQueued = false;
      scanEntryTargets();
    }, 80);
  }

  document.addEventListener('DOMContentLoaded', scanEntryTargets);
  window.addEventListener('load', scanEntryTargets);
  document.addEventListener('on:cart:add', scheduleScan);
  document.addEventListener('on:line-item:change', scheduleScan);
  document.addEventListener('on:variant:change', scheduleScan);
  document.addEventListener('dispatch:cart-drawer:refresh', scheduleScan);
  document.addEventListener('dispatch:cart-drawer:open', scheduleScan);

  const observer = new MutationObserver(scheduleScan);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  setTimeout(scanEntryTargets, 500);
  setTimeout(scanEntryTargets, 1500);
})();

(function () {
  if (window.__bcQuickEntryDirectCart) return;
  window.__bcQuickEntryDirectCart = true;

  const quickEntrySectionSelectors = [
    '[id$="__featured_collection_MLyXNz"]',
    '[id$="__featured_collection_ikmQxr"]'
  ];
  const productCache = new Map();

  function isQuickEntriesCollectionPage() {
    return window.location.pathname.replace(/\/$/, '') === '/collections/quick-entries';
  }

  function quickEntrySectionForClick(target) {
    if (isQuickEntriesCollectionPage()) return null;
    return quickEntrySectionSelectors
      .map((selector) => target.closest(selector))
      .find(Boolean) || null;
  }

  function productCardForClick(section, target) {
    const card = target.closest('product-card, .card--product');
    return card && section.contains(card) ? card : null;
  }

  function productLinkForCard(card) {
    return card.querySelector('a.js-prod-link[href*="/products/"], a.card-link[href*="/products/"], a[href*="/products/"]');
  }

  function productJsonUrl(link) {
    const url = new URL(link.getAttribute('href'), window.location.origin);
    const match = url.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return null;
    return `/products/${match[1]}.js`;
  }

  async function fetchProduct(link) {
    const jsonUrl = productJsonUrl(link);
    if (!jsonUrl) return null;
    if (!productCache.has(jsonUrl)) {
      productCache.set(jsonUrl, fetch(jsonUrl, { credentials: 'same-origin' }).then((response) => {
        if (!response.ok) throw new Error('Could not load quick entry product');
        return response.json();
      }));
    }
    return productCache.get(jsonUrl);
  }

  function firstAvailableVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    return product.variants.find((variant) => variant.available) || product.variants[0] || null;
  }

  async function addVariantToCart(variantId) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    });

    if (!response.ok) throw new Error('Could not add quick entry to cart');
    return response.json();
  }

  async function handleQuickEntryClick(event) {
    const section = quickEntrySectionForClick(event.target);
    if (!section) return;

    const card = productCardForClick(section, event.target);
    if (!card) return;

    const link = productLinkForCard(card);
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();

    if (card.dataset.bcQuickEntryAdding === 'true') return;
    card.dataset.bcQuickEntryAdding = 'true';
    card.setAttribute('aria-busy', 'true');

    try {
      const product = await fetchProduct(link);
      const variant = firstAvailableVariant(product);
      if (!variant || !variant.id) throw new Error('No quick entry variant available');

      await addVariantToCart(variant.id);
      window.location.assign('/cart');
    } catch (error) {
      console.error('Boosted quick entry add-to-cart error:', error);
      window.location.assign(link.href);
    }
  }

  document.addEventListener('click', handleQuickEntryClick, true);
})();

(function () {
  if (window.__bcSyncedTeeCarousels) return;
  window.__bcSyncedTeeCarousels = true;

  const isHome = window.location.pathname === '/' || window.location.pathname === '';
  if (!isHome) return;

  function sectionBySuffix(suffix) {
    return document.querySelector(`[id$="__${suffix}"]`);
  }

  function sliderForSection(section) {
    return section?.querySelector('.slider') || null;
  }

  const mobileQuery = window.matchMedia('(max-width: 768.98px)');
  let mobileRows = null;
  let sharedNav = null;
  let sharedNavSecond = null;
  let sharedNavObserver = null;

  function syncScroll(source, target) {
    const sourceMax = source.scrollWidth - source.clientWidth;
    const targetMax = target.scrollWidth - target.clientWidth;
    const ratio = sourceMax > 0 ? source.scrollLeft / sourceMax : 0;

    target.scrollLeft = ratio * targetMax;
  }

  function removeSharedNav() {
    sharedNavObserver?.disconnect();
    sharedNavObserver = null;
    sharedNav?.remove();
    sharedNav = null;
    sharedNavSecond = null;
  }

  function updateSharedNavState() {
    if (!sharedNav || !sharedNavSecond) return;

    const maxScroll = sharedNavSecond.scrollWidth - sharedNavSecond.clientWidth;
    const previous = sharedNav.querySelector('button[name="prev"]');
    const next = sharedNav.querySelector('button[name="next"]');

    if (previous) previous.disabled = sharedNavSecond.scrollLeft <= 1;
    if (next) next.disabled = sharedNavSecond.scrollLeft >= maxScroll - 1;
  }

  function positionSharedNav(first, second) {
    if (!sharedNav) return;

    const firstRect = first.getBoundingClientRect();
    const secondRect = second.getBoundingClientRect();
    const container = second.closest('.featured-collection-products');
    const containerRect = container?.getBoundingClientRect() || secondRect;
    const gutter = container ? parseFloat(window.getComputedStyle(container).paddingRight) || 0 : 0;
    const midpoint = window.scrollY + (firstRect.bottom + secondRect.top) / 2;
    const horizontalCenter = window.scrollX + containerRect.right - gutter;

    sharedNav.style.top = `${midpoint}px`;
    sharedNav.style.left = `${horizontalCenter}px`;
  }

  function scrollSharedNav(button) {
    if (!sharedNavSecond || button.disabled) return;

    const carousel = sharedNavSecond.closest('carousel-slider');
    const items = sharedNavSecond.querySelectorAll('.slider__item');
    const measuredSpan = items.length > 1
      ? Math.abs(items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left)
      : sharedNavSecond.clientWidth;
    const slideSpan = carousel?.slideSpan || measuredSpan;
    const slidesToScroll = carousel?.slidesToScroll || 1;
    const direction = button.name === 'next' ? 1 : -1;

    sharedNavSecond.scrollTo({
      left: sharedNavSecond.scrollLeft + direction * slideSpan * slidesToScroll,
      behavior: 'smooth'
    });
  }

  function ensureSharedNav(firstSection, secondSection, first, second) {
    if (mobileQuery.matches) {
      removeSharedNav();
      return;
    }

    const carousel = second.closest('carousel-slider');
    const originalNav = carousel?.querySelector('.featured-collection-products > .slider-nav');
    if (!originalNav) return;

    if (!sharedNav) {
      sharedNav = originalNav.cloneNode(true);
      sharedNav.classList.add('bc-tee-shared-nav');
      sharedNav.classList.remove('slider-nav--show-on-hover', 'no-hover-hidden', 'hidden', 'md:block');
      sharedNav.addEventListener('click', (event) => {
        const button = event.target.closest('.slider-nav__btn');
        if (!button) return;
        event.preventDefault();
        scrollSharedNav(button);
      });
      document.body.append(sharedNav);
    }

    sharedNavSecond = second;

    if (second.dataset.bcSharedNavStateReady !== 'true') {
      second.dataset.bcSharedNavStateReady = 'true';
      second.addEventListener('scroll', updateSharedNavState, { passive: true });
    }

    sharedNavObserver?.disconnect();
    if ('ResizeObserver' in window) {
      sharedNavObserver = new ResizeObserver(() => positionSharedNav(first, second));
      sharedNavObserver.observe(firstSection);
      sharedNavObserver.observe(secondSection);
    }

    positionSharedNav(first, second);
    updateSharedNavState();
  }

  function combineMobileRows(firstSection, secondSection, first, second) {
    if (mobileRows || !mobileQuery.matches) return;

    const firstProducts = first.querySelector('.products-grid-container');
    const secondProducts = second.querySelector('.products-grid-container');
    if (!firstProducts || !secondProducts) return;

    const firstMarker = document.createComment('bc-tee-row-a');
    const secondMarker = document.createComment('bc-tee-row-b');
    const rows = document.createElement('div');

    rows.className = 'bc-tee-mobile-rows';
    firstProducts.before(firstMarker);
    secondProducts.before(secondMarker);
    firstMarker.after(rows);
    rows.append(firstProducts, secondProducts);

    first.classList.add('bc-tee-mobile-slider');
    firstSection.classList.add('bc-tee-mobile-combined');
    secondSection.classList.add('bc-tee-mobile-source');
    first.scrollLeft = 0;

    mobileRows = {
      firstProducts,
      secondProducts,
      firstMarker,
      secondMarker,
      rows,
      firstSection,
      secondSection,
      first
    };
  }

  function restoreDesktopRows() {
    if (!mobileRows || mobileQuery.matches) return;

    const {
      firstProducts,
      secondProducts,
      firstMarker,
      secondMarker,
      rows,
      firstSection,
      secondSection,
      first
    } = mobileRows;

    firstMarker.after(firstProducts);
    secondMarker.after(secondProducts);
    firstMarker.remove();
    secondMarker.remove();
    rows.remove();
    first.classList.remove('bc-tee-mobile-slider');
    firstSection.classList.remove('bc-tee-mobile-combined');
    secondSection.classList.remove('bc-tee-mobile-source');
    mobileRows = null;
  }

  function connectTeeCarousels() {
    const firstSection = sectionBySuffix('bc_home_shirts_a');
    const secondSection = sectionBySuffix('bc_home_shirts_b');
    const first = sliderForSection(firstSection);
    const second = sliderForSection(secondSection);

    if (!first || !second) return;

    if (mobileQuery.matches) {
      removeSharedNav();
      combineMobileRows(firstSection, secondSection, first, second);
      return;
    }

    restoreDesktopRows();
    ensureSharedNav(firstSection, secondSection, first, second);

    if (first.dataset.bcTeeSyncReady === 'true') {
      syncScroll(second, first);
      return;
    }

    first.dataset.bcTeeSyncReady = 'true';
    second.dataset.bcTeeSyncReady = 'true';

    let isSyncing = false;

    function mirror(source, target) {
      if (isSyncing) return;
      isSyncing = true;
      syncScroll(source, target);
      window.requestAnimationFrame(() => {
        isSyncing = false;
      });
    }

    first.addEventListener('scroll', () => mirror(first, second), { passive: true });
    second.addEventListener('scroll', () => mirror(second, first), { passive: true });

    syncScroll(second, first);
  }

  document.addEventListener('DOMContentLoaded', connectTeeCarousels);
  window.addEventListener('load', connectTeeCarousels);
  window.addEventListener('resize', connectTeeCarousels);
  setTimeout(connectTeeCarousels, 250);
  setTimeout(connectTeeCarousels, 1000);
})();

(function () {
  if (window.__bcHomepageReflow) return;
  window.__bcHomepageReflow = true;

  const isHome = window.location.pathname === '/' || window.location.pathname === '';
  if (!isHome) return;

  const sectionBySuffix = (suffix) =>
    document.querySelector(`[id$="__${suffix}"]`);

  function firstQuickEntryImage() {
    const quickSection = sectionBySuffix('featured_collection_MLyXNz');
    const img = quickSection?.querySelector('img');
    if (!img) return null;

    return {
      src: img.currentSrc || img.src,
      srcset: img.getAttribute('srcset') || '',
      width: img.getAttribute('width') || '',
      height: img.getAttribute('height') || '',
      alt: 'Quick Entries'
    };
  }

  function addQuickEntriesCollection() {
    const collectionSection = sectionBySuffix('b7c18b78-f517-4220-a6c6-ff4ab88b41ff');
    if (!collectionSection || collectionSection.querySelector('a[href="/collections/quick-entries"]')) return;

    const list = collectionSection.querySelector('ul.slider__grid');
    if (!list) return;

    const image = firstQuickEntryImage();
    const item = document.createElement('li');
    item.className = 'slider__item bc-quick-collection-card';
    item.innerHTML = `
      <div class="card hover:grow-media relative flex flex-col card__collection card__collection--with-border">
        <div class="card__media relative card__media--circle">
          <a href="/collections/quick-entries" aria-label="Quick Entries" class="media block relative" tabindex="-1" style="padding-top: 128%;">
            ${image ? `<img src="${image.src}"${image.srcset ? ` srcset="${image.srcset}"` : ''} class="img-fit" loading="lazy"${image.width ? ` width="${image.width}"` : ''}${image.height ? ` height="${image.height}"` : ''} alt="${image.alt}">` : ''}
          </a>
        </div>
        <div class="card__info relative text-center">
          <p class="card__title h6 mb-2 last:mb-0"><a href="/collections/quick-entries" class="card-link text-current">Quick Entries</a></p>
          <a href="/collections/quick-entries" class="text-theme-text inline-flex card__collection--arrow">
            View collection
            <span class="has-ltr-icon flex items-center mis-2"><svg width="18" height="19" viewBox="0 0 17.99 18.62" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M4.77 9.31h7.81M8.86 5.17l4 4.14-4 4.14" fill="none" stroke="currentColor" stroke-width="1.25"/><ellipse cx="9" cy="9.31" rx="8.37" ry="8.69" fill="none" stroke="currentColor" stroke-width="1.25"/></svg></span>
          </a>
        </div>
      </div>
    `;

    list.prepend(item);
  }

  function applyHomepageFixes() {
    addQuickEntriesCollection();
  }

  document.addEventListener('DOMContentLoaded', applyHomepageFixes);
  window.addEventListener('load', applyHomepageFixes);
  setTimeout(applyHomepageFixes, 250);
  setTimeout(applyHomepageFixes, 1000);
})();
